import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const TimerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 24px;
  background-color: #FFECDB;
  padding: 16px 24px;
  border-radius: 12px;
`;

const TimerTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #323232;
  letter-spacing: -0.2px;
  margin-bottom: 4px;
`;

const TimeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const TimeItem = styled.div`
  font-weight: 800;
  font-size: 20px;
  line-height: 24px;
  color: #F58A3C;
  border-radius: 8px;
  position: relative;

  span {
    font-weight: 800;
    font-size: 12px;
    line-height: 14px;
    margin-left: 1px;
  }

  &:not(:last-child) {
    margin-right: 14px;
    &:after {
      content: ":";
      display: block;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      position: absolute;
      top: 0px;
      right: -10px;
    }
  }
`;

const TimerTime = styled.div`
	font-weight: 700;
	font-size: 20px;
	line-height: 24px;
	color: #0F0E0E;
`;

export const checkNumber = (value) => {
  value = value.toString();
  if (value.length === 1) {
    return `0${value}`;
  }
  return value;
};

export const useTimer = (initialMinutes) => {

  const initialSeconds = 0;

  const [minutes, setMinutes] = useState(initialMinutes || 10);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const savedMinutes = sessionStorage.getItem("timerMinutes");
    const savedSeconds = sessionStorage.getItem("timerSeconds");

    if (savedMinutes && savedSeconds) {
      setMinutes(parseInt(savedMinutes, 10));
      setSeconds(parseInt(savedSeconds, 10));
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (minutes === 0 && seconds === 0) {
        clearInterval(interval);
        return;
      }

      if (seconds > 0) {
        setSeconds((prevSeconds) => prevSeconds - 1);
      } else {
        setMinutes((prevMinutes) => prevMinutes - 1);
        setSeconds(59);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [minutes, seconds]);

  useEffect(() => {
    sessionStorage.setItem("timerMinutes", minutes);
    sessionStorage.setItem("timerSeconds", seconds);
  }, [minutes, seconds]);

  return { minutes, seconds };
};

export const TimerSimple = () => {
  const { minutes, seconds } = useTimer();

  return <TimerTime>{`${minutes}:${checkNumber(seconds)}`}</TimerTime>
};

const Timer = ({initialMinutes = 10, withHours = true}) => {
  const { t } = useTranslation();
  const { minutes, seconds } = useTimer(initialMinutes);

  return (
    <TimerContainer>
      <TimerTitle>{t("limited_offer")}:</TimerTitle>
      <TimeWrapper>
        {withHours && <TimeItem>
          0<span>{t("hours")}</span>
        </TimeItem>}
        <TimeItem>
          {`${minutes.toString().padStart(2, "0")}`}
          <span>{t("minutes")}</span>
        </TimeItem>
        <TimeItem>
          {`${seconds.toString().padStart(2, "0")}`}
          <span>{t("seconds")}</span>
        </TimeItem>
      </TimeWrapper>
    </TimerContainer>
  );
};

export default Timer;
